export const ThreatMetricsHandler = {
    data: function() {
        return {
            usesThreatMetricsOnly: false,
            domain: "",
            orgId: "",
            profileCallerId: "",
        }
    },

    methods: {
        beginThreatMetrics: function(clientProfile) {
            if (clientProfile.maProvider === "DUAL" || clientProfile.maProvider === "TM") {
                if (clientProfile.maProvider === "TM") {
                    this.usesThreatMetricsOnly = true;
                }
                this.domain = clientProfile.tmDomain;
                this.orgId = clientProfile.tmOrgId;
                this.retrieveProfileCallerId()
            }
        },

        retrieveProfileCallerId: function() {
            this.profileCallerId = generateTMXToken();
            this.startThreatMetrics();
        },
        
        startThreatMetrics: function() {
            ktbdnc.profile(this.domain, this.orgId, this.profileCallerId);
        }
    }
}